export default __webpack_public_path__ + "static/media/caebes-logo.48696b9b.svg";